import { Loader2 } from 'lucide-react';

/**
 * §13 — Yükleniyor göstergesi. Referans panelde marka renkli `Loader2` dönen ikonu
 * kullanılır. Ekran okuyucular için `role="status"` + gizli metin korunur.
 */

export interface SpinnerProps {
  /** sm: satır içi, md: kart içi, lg: sayfa ortası */
  size?: 'sm' | 'md' | 'lg';
  /** Görünür etiket; verilmezse yalnızca ekran okuyucu metni kullanılır. */
  label?: string;
  className?: string;
}

const SIZES: Record<NonNullable<SpinnerProps['size']>, string> = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-7 w-7',
};

export default function Spinner({ size = 'md', label, className = '' }: SpinnerProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={`inline-flex items-center gap-2 text-[#6b7280] ${className}`}
    >
      <Loader2 aria-hidden="true" className={`${SIZES[size]} animate-spin text-brand`} />
      {label !== undefined ? <span className="text-[13px]">{label}</span> : null}
      <span className="sr-only">{label ?? 'Yükleniyor'}</span>
    </div>
  );
}

/** Kart/sayfa gövdesini ortalayan yükleme bloğu — sayfaların tekrar yazmaması için. */
export function LoadingBlock({ label = 'Yükleniyor…' }: { label?: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16">
      <Loader2 aria-hidden="true" className="h-7 w-7 animate-spin text-brand" />
      <p role="status" aria-live="polite" className="text-[13px] text-[#6b7280]">
        {label}
      </p>
    </div>
  );
}
